<template>
  <section>
    <router-view></router-view>
  </section>
</template>

<script>
const ignoreErrors = ["ResizeObserver loop completed with undelivered notifications", "ResizeObserver loop limit exceeded"]
window.addEventListener('error', e => {
  let errorMsg = e.message;
  ignoreErrors.forEach(m => {
    if (errorMsg.startsWith(m)) {
      if (e.error) {
      }
      const resizeObserverErrDiv = document.getElementById(
        'webpack-dev-server-client-overlay-div'
      );
      const resizeObserverErr = document.getElementById(
        'webpack-dev-server-client-overlay'
      );
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute('style', 'display: none');
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute('style', 'display: none');
      }
    }
  })
});

function isMobile() {
  const ua = navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

  // 2. 检测触摸屏支持
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 3. 检测屏幕特性 (考虑折叠屏等新型设备)
  const screenRatio = window.screen.width / window.screen.height;
  const isSmallScreen = window.screen.width <= 768 || screenRatio > 2 || screenRatio < 0.5;

  // 4. 综合判断 (优先UA检测，其次特征检测)
  return mobileRegex.test(ua) || (hasTouch && isSmallScreen);
}  
  
if (isMobile()) {  
    console.log('当前在移动端');  
    window.location.href = 'http://hudaxia.net'
    // window.location.href = 'http://localhost:5173/web/#/'
} else {
    console.log('当前在PC端');
}
</script>

<style scoped lang="scss">
html {
  font-size: 14px;
}

body {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
</style>
